
import './styles.css'

export const tour_steps = [
  {
    selector: '',
    content:
      "Welcome to Extreme Reading, an interactive review summary explorer that makes reviews easier to interpret by generating both structured and abstractive textual summaries.",

    actionBefore: async () => {
      await setTimeout(5000)
      console.log('Hola!')
    }
  },
  {
    selector: '[data-tut="title-bar"]',
    content: "Let's start by exploring this hotel!",
    position: [400, 200]
  },
  {
    selector: '[data-tut="summary"]',
    content: "Here's a textual summary that provides a concise overview of opinions mentioned in the reviews relevant to your search, making it easy to interpret the overall sentiment of relevant reviews."
  },
  {
    selector: '[data-tut="graph_reviews"]',
    content: "Single click either a node or arrow to see relevant reviews on our review panel, double click eligible nodes to dive into those nodes, drag nodes to reposition them.",
  },
  {
    selector: '[data-tut="graph_reviews"]',
    content: "Darker nodes represent more general opinions while larger nodes represent more frequent opinions."
  },
  {
    selector: '[data-tut="reviews"]',
    content: "Here you can find the customer reviews relevant to the node or arrow you have selected within the graph."
  },
  {
    selector: '[data-tut="banner"]',
    content: "For more background information on this project go to our publications and feel free to give us feedback. Happy exploring! ",
    position: [500, 100]
  }
]
